import MasterProductCURModule from "@/modules/MasterProductCUR";

function CreateMasterProductPage() {
  return <MasterProductCURModule type="create" />;
}

export default CreateMasterProductPage;
